import { get } from 'lodash'
import { getCardByUid } from './server/api/cards'
import { getBrandByUid } from './server/api/brands'
import { getStoreLocatorByUid } from './server/api/storeLocators'

export const getAccessibilityWidgetProps = (req) => {
  const query = { ...req.query }
  const { uid: cardUid, orientation = 'horizontal' } = query

  delete query.uid

  return getCardByUid(cardUid, query, req.headers)
    .then((json) => {
      const handicaps = get(
        json,
        ['accessibility_description', 'handicaps'],
        {}
      )
      const pictureUrl =
        get(json, ['picture', 'thumb_url'], null) ||
        get(json, ['picto', 'thumb_url'], null)
      const cardUrl = json.slug
        ? `${process.env.RAZZLE_APP_URL}cards/${json.slug}`
        : null
      return { handicaps, pictureUrl, cardUrl, orientation, cardUid: json.uuid }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}

export const getModalWidgetProps = (req) => {
  const query = { ...req.query }
  const { uid: cardUid } = query

  delete query.uid

  return getCardByUid(cardUid, query, req.headers)
    .then((json) => {
      return { card: json }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}

export const getVerticalAndHorizontalWidgetProps = (req) => {
  const query = { ...req.query }
  const { uid: cardUid } = query

  delete query.uid

  return getCardByUid(cardUid, query, req.headers)
    .then((json) => {
      const handicaps = get(
        json,
        ['accessibility_description', 'handicaps'],
        {}
      )
      const cardUrl = json.slug
        ? `${process.env.RAZZLE_APP_URL}cards/${json.slug}`
        : null

      const pictureUrl = json.picto.thumb_url
      const picture = pictureUrl.split('//')[1].split('?')[0]
      return { handicaps, cardUrl, picture, cardUid: json.uuid }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}

export const getButtonWidgetProps = (req) => {
  const query = { ...req.query }
  const {
    uid: cardUid,
    'button-color': buttonColor = '81C25D',
    'button-text': buttonText = '',
    variant = null,
  } = query

  delete query.uid
  delete query['button-color']
  delete query['button-text']
  delete query.variant

  return getCardByUid(cardUid, query, req.headers)
    .then((json) => {
      const cardUrl = json.slug
        ? `${process.env.RAZZLE_APP_URL}cards/${json.slug}`
        : null
      return { cardUrl, buttonColor, buttonText, variant, cardUid: json.uuid }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}

export const getBrandWidgetProps = (req) => {
  const query = { ...req.query }
  const { uid: brandUid } = query

  delete query.uid

  return getBrandByUid(brandUid, query, req.headers)
    .then((json) => {
      const brandUrl = json.slug
        ? `${process.env.RAZZLE_APP_URL}brands/${json.slug}`
        : null
      const name = get(json, 'name', '')
      const cardsCount = get(json, 'cards_count', 0)
      const logo = get(json, 'logo', {})
      return { brandUrl, name, cardsCount, logo, brandUid: json.uuid }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}

export const getStoreLocatorWidgetProps = (req) => {
  const query = { ...req.query }
  const { uid: storeLocatorUid } = query

  delete query.uid

  return getStoreLocatorByUid(storeLocatorUid, query, req.headers)
    .then((json) => {
      const storeLocatorUrl = json.slug
        ? `${process.env.RAZZLE_APP_URL}store_locator/${json.slug}`
        : null

      const title = get(json, 'title', '')
      const cardsCount = get(json, 'cards_count', 0)
      const logo = get(json, 'logo', {})
      return {
        storeLocatorUrl,
        title,
        cardsCount,
        logo,
        storeLocatorUid: json.uuid,
      }
    })
    .catch((err) => {
      return { error: err.toString() }
    })
}
